<h2
  mat-dialog-title
  class="cut-long-text"
>{{ "select_medium" | transloco }}</h2>

<mat-divider></mat-divider>

<div class="searchRow">
  <pixl-free-filter-input
    [label]="'name' | transloco"
    [matIcon]="'search'"
    [hint]="getSearchFilterHint()"
    [minLength]="freeFilterLen"
    (onKeyUpChange)="setFreeFilter($event)"
  />
  &nbsp;
  <mat-form-field>
      <mat-label>{{ "subjects" | transloco }}</mat-label>
      <mat-select
          multiple
          (valueChange)="setSubjectFilter($event)"
      >
          @for (subject of subjects$ | async; track subject) {
          <mat-option [value]="subject.treeId">{{subject.name}}</mat-option>
          }
      </mat-select>
  </mat-form-field>
  &nbsp;
  <pixl-state-cb
    (onStateChange)="setStatusFilter($event)"
    [withEmptyOption]="true"
    [initValue]="getInitOption()"
  />
</div>

<mat-divider></mat-divider>

<mat-dialog-content class="mat-typography">
  <div class="main-table">
    <div class="table-container mat-elevation-z4">
      @if (assets$ | async; as assets) {
        <table
          mat-table
          [dataSource]="assets"
          matSort
          (matSortChange)="announceSortChange($event)"
        >

          <ng-container matColumnDef="action">
            <th
              mat-header-cell
              *matHeaderCellDef
            >{{ "actions" | transloco }}</th>
            <td
              mat-cell
              *matCellDef="let asset; let idx = index"
            >
              <button
                mat-icon-button
                aria-label="Edit"
                (click)="takeAsset(asset)"
                [matTooltip]="'take_medium' | transloco"
              >
                <mat-icon>add_shopping_cart</mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >{{ "name" | transloco }}</th>
            <td
              mat-cell
              *matCellDef="let asset"
            >{{ asset.name }}</td>
          </ng-container>

          <ng-container matColumnDef="tags">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
            >{{ "tags" | transloco }}</th>
            <td
              mat-cell
              *matCellDef="let asset"
            >
              @if(asset.tags) {
              @for (tag of asset.tags; track tag) {
              <button
                type="button"
                class="button-tag"
              >{{ tag }}</button>
              &nbsp;
              }
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="image">
            <th
              mat-header-cell
              *matHeaderCellDef
            >{{ "preview_label" | transloco }}</th>
            <td
              mat-cell
              *matCellDef="let asset"
            >
              <img
                src="{{ getImageUrl(asset)}}"
                alt=""
                width="30px"
                height="30px"
              />
            </td>
          </ng-container>

          <ng-container matColumnDef="audio">
            <th
              mat-header-cell
              *matHeaderCellDef
            >{{ "listen" | transloco }}</th>
            <td
              mat-cell
              *matCellDef="let asset"
            >
              <audio
                #mobileAudioCtrl
                controls
                preload="auto"
                class="audio-control"
              >
                <source
                  src="{{ getAudioUrl(asset) }}"
                  type="audio/mpeg"
                >
                Your browser does not support the audio element.
              </audio>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="columnsToDisplay; sticky: true"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: columnsToDisplay"
          ></tr>
        </table>
      } @else {
          <pixl-table-loading-spinner [name]="'medium' | transloco" />
      }

      <mat-paginator
          [length]="totalItems || 0"
          [pageSize]="pageSize"
          [pageSizeOptions]="[5, 10, 20]"
      ></mat-paginator>
    </div>
  </div>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions>
  <button
    mat-raised-button
    (click)="onCancel()"
  >{{ "abort" | transloco }}</button>
</mat-dialog-actions>